<main @fade>

  <nb-card [nbSpinner]="loading">
    <nb-card-header>
      <h4>Импорт содержимого Яндекс диска в хранилище документов</h4>
    </nb-card-header>
    <nb-card-body>

      <ng-container *ngIf="(downloadingStatus | async)?.isDownloading">
        <div class="row">
          <div [ngClass]="'col-lg-7 n-part-left'" [nbSpinner]="true">
            <nb-alert status="warning" size="small">Идет загрузка и обработка папки из Яндекс диска. Дождитесь окончания</nb-alert>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="(downloadComplete | async)">
        <div class="row">
          <div [ngClass]="'col-lg-7 n-part-left'">
            <nb-alert status="success" size="small">Загрузка завершена</nb-alert>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="(downloadingStatus | async)?.isDownloading === false">
        <div class="row">
          <div [ngClass]="'col-lg-7 n-part-left'">
            <form [formGroup]="form" (ngSubmit)="onSubmit()">
              <h5>Шаг 1 - Авторизация</h5>

              <formly-form [form]="form" [fields]="fields" [options]="options" [model]="model"></formly-form>
              <button nbButton status="primary" type="submit" [disabled]="!form.valid || loading" i18n>авторизоваться</button>

            </form>
          </div>
        </div>


        <div class="row" *ngIf="step2">
          <div [ngClass]="'col-lg-7 n-part-left'">
            <h5>Шаг 2 - Импорт категории</h5>
            <ng-select [items]="yandexFolders"
                       [placeholder]="'Папки Яндекс диска'"
                       [virtualScroll]="true"
                       appendTo="body"
                       (scroll)="onScroll($event)"
                       (scrollToEnd)="onScrollToEnd()"
                       bindLabel="header"
                       bindValue="id"
                       [(ngModel)]="yandexSelectedFolder">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <span [innerHTML]="item" style="white-space: pre"></span>
              </ng-template>
            </ng-select>
            <small class="form-text text-muted">Выберите папку из которой надо осуществить импорт</small>
          </div>
        </div>
        <div class="row" *ngIf="step2">
          <div [ngClass]="'col-lg-7 n-part-left'">

            <ng-select [items]="damFolders | async"
                       [placeholder]="'Разделы'"
                       appendTo="body"
                       bindLabel="header"
                       bindValue="id"
                       [(ngModel)]="damSelectedFolder">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <span [innerHTML]="item.header" style="white-space: pre"></span>
              </ng-template>
            </ng-select>
            <small class="form-text text-muted">Выберите раздел в который надо осуществить импорт</small>

            <button nbButton status="primary" type="button" (click)="download()" [disabled]="!form.valid || !this.damSelectedFolder || !this.yandexSelectedFolder" i18n>начать перенос</button>

          </div>
        </div>
      </ng-container>
    </nb-card-body>
  </nb-card>
</main>
